import React, { FC } from 'react';
import { useTranslation } from '@blocs.i18n';
import styled from 'styled-components';
import { BrazeEvents, trackBrazeEvent } from '@blocs.braze';
import { grid } from '@minecraft.themes';
import Icon from '@minecraft.icon';
import Button from '@minecraft.button';
import { usePermissions } from '@minecraft.permissions';
import { gqlSubscriptionStatusEnum } from '@minecraft.graphql-types';
import { useArtistContext } from '../ArtistContext';

const StyledIcon = styled(Icon)`
  margin-right: 0.313rem;
`;

const StyledButton = styled(Button)`
  text-decoration: none;
  font-size: 0.75rem;
  font-weight: 600;
  margin-right: 0.625rem;
  color: white !important;
  background-color: ${({ theme }) => theme.colors.accent.darkGreen};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;

  @media screen and (max-width: ${grid.breakpoints.xxlg}) and (min-width: ${grid.breakpoints.md}) {
    position: absolute !important;
    right: 19rem;
    top: 1rem;
  }
`;

type Props = {
  openBilling: () => void;
};

export const UpgradeMembershipButton: FC<Props> = ({ openBilling }) => {
  const { t } = useTranslation();
  const { ability } = usePermissions();
  const { subscriptionStatus } = useArtistContext();
  const canUpgrade = ability.can('upgrade', 'subscription');
  const isSubscriptionPaused = subscriptionStatus === gqlSubscriptionStatusEnum.PAUSED;

  const openAndFire = () => {
    const creationDate = new Date();
    // eslint-disable-next-line camelcase
    trackBrazeEvent(BrazeEvents.TalentTapsGlobalUpgradeButton, { date_created: creationDate.toISOString() });
    openBilling();
  };

  if (!isSubscriptionPaused && !canUpgrade) {
    return null;
  }

  return (
    <StyledButton color="primary" onClick={openAndFire}>
      <StyledIcon name="rocket" color="white" />
      {isSubscriptionPaused ? t('common:membership.reactivateMembership') : t('common:membership.upgradeNow')}
    </StyledButton>
  );
};
